import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { action } from "typesafe-actions";
import { companyApi } from "../../api/talent/company-service";
import { processStepApi } from "../../api/talent/process-step-service";
import { talentApi } from "./../../api/talent/talent-service";
import { AppState } from "./../app-state";
import { CompanyActionTypes } from "./company-types";
import { authenticationApi } from "../../api/talent/authentication-service";
import { AuthActionTypes } from "../auth/auth-types";
import { CompanyProfileActionTypes } from "../company-profile/company-profile.types";

export const fetchLastInvoice = () => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(CompanyActionTypes.FETCH_LAST_INVOICE));
    try {
      const response = await companyApi.fetchLastInvoice();
      dispatch(
        action(CompanyActionTypes.FETCH_LAST_INVOICE_SUCCESS, response.data)
      );
    } catch (error) {
      dispatch(action(CompanyActionTypes.FETCH_LAST_INVOICE_ERROR, error));
    }
  };
};

export const fetchCompanyPlan = () => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(CompanyActionTypes.FETCH_COMPANY_PLAN));
    try {
      const response = await talentApi.fetchTalentPlan();
      dispatch(
        action(CompanyActionTypes.FETCH_COMPANY_PLAN_SUCCESS, response.data)
      );
    } catch (error) {
      dispatch(action(CompanyActionTypes.FETCH_COMPANY_PLAN_ERROR, error));
    }
  };
};

export const fetchProcessSteps = (companyId: string) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(CompanyActionTypes.FETCH_PROCESS_STEPS));

    try {
      const response = await processStepApi.fetchProcessSteps(companyId);
      dispatch(
        action(CompanyActionTypes.FETCH_PROCESS_STEPS_SUCCESS, response.data)
      );
    } catch (error) {
      dispatch(action(CompanyActionTypes.FETCH_PROCESS_STEPS_ERROR, error));
    }
  };
};

export const createCandidateProcessStep = (
  candidateId: string,
  processStepId: string,
  recruiterId: string
) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(CompanyActionTypes.CREATE_CANDIDATE_PROCESS_STEP));

    try {
      const response = await processStepApi.createCandidateProcessStep(
        candidateId,
        processStepId,
        recruiterId
      );
      dispatch(
        action(
          CompanyActionTypes.CREATE_CANDIDATE_PROCESS_STEP_SUCCESS,
          response.data
        )
      );
    } catch (error) {
      dispatch(
        action(CompanyActionTypes.CREATE_CANDIDATE_PROCESS_STEP_ERROR, error)
      );
    }
  };
};

export const fetchSelectedCandidatesProcessSteps = (uuids: string[]) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(
      action(CompanyActionTypes.FETCH_SELECTED_CANDIDATES_PROCESS_STEPS)
    );

    try {
      const response = await processStepApi.fetchSelectedCandidatesProcessSteps(
        uuids
      );
      dispatch(
        action(
          CompanyActionTypes.FETCH_SELECTED_CANDIDATES_PROCESS_STEPS_SUCCESS,
          response.data
        )
      );
    } catch (error) {
      dispatch(
        action(
          CompanyActionTypes.FETCH_SELECTED_CANDIDATES_PROCESS_STEPS_ERROR,
          error
        )
      );
    }
  };
};

export const fetchCandidateProcessStep = (candidateId: string) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(CompanyActionTypes.FETCH_CANDIDATE_PROCESS_STEP));

    try {
      const response = await processStepApi.fetchCandidateProcessStep(
        candidateId
      );
      dispatch(
        action(
          CompanyActionTypes.FETCH_CANDIDATE_PROCESS_STEP_SUCCESS,
          response.data
        )
      );
    } catch (error) {
      dispatch(
        action(CompanyActionTypes.FETCH_CANDIDATE_PROCESS_STEP_ERROR, error)
      );
    }
  };
};

export const updateCandidateProcessStep = (
  candidateId: string,
  processStepId: string,
  recruiterId: string
) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(CompanyActionTypes.UPDATE_CANDIDATE_PROCESS_STEP));

    try {
      const response = await processStepApi.updateCandidateProcessStep(
        candidateId,
        processStepId,
        recruiterId
      );
      dispatch(
        action(
          CompanyActionTypes.UPDATE_CANDIDATE_PROCESS_STEP_SUCCESS,
          response.data
        )
      );
    } catch (error) {
      dispatch(
        action(CompanyActionTypes.UPDATE_CANDIDATE_PROCESS_STEP_ERROR, error)
      );
    }
  };
};

export const fetchRecruiters = (companyId: string) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(CompanyActionTypes.FETCH_RECRUITERS));
    try {
      const response = await companyApi.fetchRecruiters(companyId);
      dispatch(
        action(CompanyActionTypes.FETCH_RECRUITERS_SUCCESS, response.data)
      );
    } catch (error) {
      dispatch(action(CompanyActionTypes.FETCH_RECRUITERS_ERROR, error));
    }
  };
};

export const updateUserCompany = (
  companyName: string,
  companySize: string,
  reason: string,
) => {
  return async (dispatch: ThunkDispatch<AppState, void, Action>) => {
    dispatch(action(CompanyActionTypes.UPDATE_USER_COMPANY));
    try {
      const response = await companyApi.updateUserCompany(
        companyName,
        companySize,
        reason,
      );
      const userResponse = await authenticationApi.getUser();
      dispatch(action(AuthActionTypes.GET_USER_SUCCESS, userResponse?.data));
      dispatch(action(CompanyProfileActionTypes.GET_COMPANY_PROFILE_SUCCESS, userResponse.data.user.corporate));
      dispatch(
        action(CompanyActionTypes.UPDATE_USER_COMPANY_SUCCESS, response.data)
      );
    } catch (error) {
      dispatch(action(CompanyActionTypes.UPDATE_USER_COMPANY_ERROR, error));
    }
  };
};
